module.exports = require("@bechtel/client-weld-common/src/components/atoms/i18n-message-keys");